const sticky = {
	header: document.querySelector('.site-header'), // Get the header
	trigger: 60, // Get scroll trigger
	minWidth: 1023,
	minHeight: 500,
};

// Add the sticky class to the navbar when you reach its scroll position.
// Remove "sticky" when you leave the scroll position
sticky.makeSticky = function () {
	if (
		window.innerWidth > sticky.minWidth &&
		window.innerHeight > sticky.minHeight &&
		window.pageYOffset >= sticky.trigger
	) {
		sticky.header.classList.add('sticky');
	} else {
		sticky.header.classList.remove('sticky');
	}
};

// Clone Member Login/Profile links
// sticky.cloneLoginLinks = function() {
// 	let loginElements = document.querySelector('.login-controls');
// 	let mainNav = document.getElementById('main-nav');
// 	let searchButton = document.getElementById('search');
// 	if (loginElements && mainNav && searchButton) {
// 		let loginClone = loginElements.cloneNode(true);
// 		mainNav.insertBefore(loginClone, searchButton);
// 	}
// };

// When the user scrolls the page, execute makeSticky
if (sticky.header) {
	window.onscroll = function () {
		if (window.innerHeight + window.scrollY >= document.body.scrollHeight) {
			return;
		} else {
			sticky.makeSticky();
		}
	};
	window.addEventListener('resize', sticky.makeSticky); //resize event
	// sticky.cloneLoginLinks();
}
